import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../store";
import { useParams } from "react-router-dom";
import {
  clearAdminTonneDefektItem,
  getAdminTonneDefektItemById,
  updateStatusById,
} from "../../store/slices/tonneDefect";
import { setDataLoading } from "../../store/slices/admin";
import { statuses } from "../AdminSperrmuelanmeldungen";
import { format } from "date-fns";
import { de } from "date-fns/locale";
import {
  AdminContentWrapper,
  AdminDetailInfoItem,
  AdminDetailPageHeader,
  AdminDetailsPageItemName,
  Button,
  Loader,
  History,
  CheckboxV2,
  CustomInputV2,
} from "../../components";
import transformHexToRgba from "../../util/transformHexToRgba";
import appConfig from "../../util/appConfig";

const AdminTonneDefektById = () => {
  const dispatch = useAppDispatch();
  const { id } = useParams();

  const { isAdminLoaderActive } = useAppSelector((state) => state.admin);
  const { isTonneDefektDataLoading, tonneDefektDataItem } = useAppSelector(
    (state) => state.tonneDefekt.admin,
  );

  const [isWeekSelected, setIsWeekSelected] = useState(true);
  const [calendarWeek, setCalendarWeek] = useState(0);

  useEffect(() => {
    if (id) {
      dispatch(getAdminTonneDefektItemById(id));
    }
    return () => {
      dispatch(clearAdminTonneDefektItem());
      dispatch(setDataLoading(false));
    };
  }, []);

  const items = [
    {
      title: "",
      items: [
        {
          rowTitle: "Status",
          rowInfo: statuses[tonneDefektDataItem?.status!],
        },
        {
          rowTitle: "Datum (Meldung)",
          rowInfo: tonneDefektDataItem
            ? format(
                new Date(tonneDefektDataItem?.createdAt),
                "dd.MM.yyyy, HH:mm",
                {
                  locale: de,
                },
              )
            : "",
          isLast: true,
        },
      ],
    },
    {
      title: "Kontaktdaten",
      items: [
        {
          rowTitle: "Name",
          rowInfo: `${tonneDefektDataItem?.userSurname}, ${tonneDefektDataItem?.userName}`,
        },
        {
          rowTitle: "Straße",
          rowInfo: `${tonneDefektDataItem?.street}
                      ${tonneDefektDataItem?.homeNumber}
                      ${
                        tonneDefektDataItem?.hausNrZusatz
                          ? `${tonneDefektDataItem?.hausNrZusatz}`
                          : ""
                      }`,
        },
        {
          rowTitle: "Ort",
          rowInfo: `${tonneDefektDataItem?.place}`,
        },
        {
          rowTitle: "Telefonnummer",
          rowInfo: `${
            tonneDefektDataItem?.phoneNumber
              ? "+" + tonneDefektDataItem?.phoneNumber
              : "-"
          }`,
        },
        {
          rowTitle: "E-Mail",
          rowInfo: `${tonneDefektDataItem?.email}`,
          isLast: true,
        },
      ],
    },
    {
      title: "Tonneninformation",
      items: [
        {
          rowTitle: "Objekt ID",
          rowInfo: `${tonneDefektDataItem?.objectId ?? ""}`,
        },
        {
          rowTitle: "Nachricht",
          rowInfo: `${tonneDefektDataItem?.message ?? "-"}`,
        },
        {
          rowTitle: "Tonnen ID",
          rowInfo: `${tonneDefektDataItem?.tonnenNummer ?? ""}`,
        },
        {
          rowTitle: "Tonnentyp",
          rowInfo: `${tonneDefektDataItem?.tonnenType}`,
        },
        {
          rowTitle: "Tonnenvolumen",
          rowInfo: `${tonneDefektDataItem?.tonnenVolume}L`,
        },
        {
          rowTitle: "Grund",
          rowInfo: `${tonneDefektDataItem?.tonnenDefectReason}`,
        },
      ],
    },
  ];

  const checkboxesToMap = [
    {
      onChange: () => {
        setIsWeekSelected(true);
      },
      text: "Der Auftrag wird nächste Woche durchgeführt.",
      value: isWeekSelected,
      withTextInput: false,
    },
    {
      onChange: () => {
        setIsWeekSelected(false);
      },
      text: `Der Auftrag wird voraussichtlich in Kalenderwoche ${calendarWeek} durchgeführt.`,
      value: !isWeekSelected,
      withTextInput: true,
    },
  ];

  return (
    <div
      style={{
        position: "relative",
      }}
    >
      <AdminDetailPageHeader isBtnAvailable={false} />
      <AdminContentWrapper>
        <AdminDetailsPageItemName text="Detailinformationen" />
        {isTonneDefektDataLoading ? null : !tonneDefektDataItem ? null : (
          <div>
            {items.map((el, idx) => {
              return (
                <AdminDetailInfoItem
                  items={el.items}
                  title={el.title}
                  key={idx}
                />
              );
            })}
            {tonneDefektDataItem?.history?.length ? (
              <History history={tonneDefektDataItem?.history} />
            ) : null}
            <div
              style={{
                display:
                  tonneDefektDataItem?.status === "accepted" ? "none" : "flex",
                flexDirection: "column",
                gap: "20px",
                marginBottom: "20px",
              }}
            >
              {checkboxesToMap.map((el, idx) => {
                return (
                  <div
                    key={idx}
                    style={{
                      display: "flex",
                      gap: "40px",
                      flexDirection: "row",
                    }}
                  >
                    <CheckboxV2
                      onChange={el.onChange}
                      text={el.text}
                      value={el.value}
                      customStyle={{
                        maxWidth: "400px",
                      }}
                      width="auto"
                    />
                    {el.withTextInput ? (
                      <CustomInputV2
                        id="calenderWeek"
                        label="Kalender Woche"
                        onChange={(v) => setCalendarWeek(+v)}
                        value={calendarWeek.toString()}
                        width="150"
                        isDisabled={isWeekSelected}
                      />
                    ) : null}
                  </div>
                );
              })}
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Button
                text="Akzeptieren"
                width="200"
                isOutlined
                outlineColor={
                  tonneDefektDataItem?.status === "accepted" ||
                  (!isWeekSelected && calendarWeek === 0)
                    ? transformHexToRgba(appConfig.mainColor, "0.4")
                    : appConfig.mainColor
                }
                textColor={
                  tonneDefektDataItem?.status === "accepted" ||
                  (!isWeekSelected && calendarWeek === 0)
                    ? transformHexToRgba(appConfig.mainColor, "0.4")
                    : appConfig.mainColor
                }
                disabled={
                  tonneDefektDataItem?.status === "accepted" ||
                  (!isWeekSelected && calendarWeek === 0)
                }
                marginRight="20"
                onClick={() => {
                  if (id) {
                    dispatch(
                      updateStatusById({
                        id: id,
                        status: "accepted",
                        message: isWeekSelected
                          ? "Der Auftrag wird nächste Woche durchgeführt."
                          : `Der Auftrag wird voraussichtlich in Kalenderwoche ${calendarWeek} durchgeführt.`,
                      }),
                    );
                  }
                }}
              />
              <Button
                text="Stornieren"
                width="200"
                backgroundColor="white"
                isOutlined
                outlineColor={
                  tonneDefektDataItem?.status === "declined"
                    ? transformHexToRgba("#ff0000", "0.4")
                    : "red"
                }
                textColor={
                  tonneDefektDataItem?.status === "declined"
                    ? transformHexToRgba("#ff0000", "0.4")
                    : "red"
                }
                disabled={tonneDefektDataItem?.status === "declined"}
                marginRight="20"
                onClick={() => {
                  if (id) {
                    dispatch(
                      updateStatusById({
                        id: id,
                        status: "declined",
                      }),
                    );
                  }
                }}
              />
            </div>
          </div>
        )}
      </AdminContentWrapper>
      {isAdminLoaderActive && <Loader />}
    </div>
  );
};

export default AdminTonneDefektById;
